import { connect, injectReducer, injectSaga } from '@vfde-sails/core';
import saga from './saga';
import reducer from './reducer';
import * as mapDispatch from './action';
import { State, mapStateToProps } from './selector';
import { mountLoadingSpinner, setLoadingSpinnerVisibility } from '../../components/loadingSpinner';
import { AppId, CustomerInfoId } from '../../enums/elementId';
import { getUpdateFlags } from './update';
import routerPickerContainer from '../RouterSelection/index';
import priceContainer from '../PriceSection/index';
import nonBookableCardContainer from '../NonBookableSection/index';
import { Namespace } from '../../enum';
import { loadInitialAppState } from '../../util/initialState';
import { mountImage, updateImage } from '../../components/image';
import { mountAccordion } from '../../components/accordion';
import { updateCustomerInfo } from '../../components/customerInfo';
import isCmsConfigValid from '../../util/cmsConfigValidator';
import { debugInfo } from '../../util/debug';
import { ErrorType } from './enum';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { initFootnotes } from '../../components/footnote';

const mountApp = (actions: typeof mapDispatch) => {
    if (!isCmsConfigValid()) {
        actions.setError({
            error: Error('Invalid CMS config!'),
            type: ErrorType.CMS_CONFIG,
        });

        debugInfo('CMS Config is invalid!');

        return {
            loadingSpinner: null,
            routerImage: null,
        };
    }

    routerPickerContainer();
    priceContainer();
    nonBookableCardContainer();

    actions.initStore(loadInitialAppState());

    mountAccordion(AppId.ACCORDION_FAQ);

    return {
        loadingSpinner: mountLoadingSpinner(AppId.LOADING_SPINNER),
        routerImage: mountImage(AppId.ROUTER_IMAGE),
    };
};

function container(_: State, actions: typeof mapDispatch) {
    injectSaga(Namespace.APP, saga);
    injectReducer(Namespace.APP, reducer);

    const { loadingSpinner, routerImage } = mountApp(actions);
    const footnoteAccordion = mountAccordion(AppId.FOOTNOTE_ACCORDION);

    initFootnotes(footnoteAccordion);

    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const {
                isLoading,
                selectedId,
                customer,
                isLoggedIn,
                isAvcError,
                isCmsError,
                isJarvisError,
                disableBooking,
            } = newState;
            const isInitError = isCmsError || isJarvisError;
            const update = getUpdateFlags(newState, oldState);

            update.loading && setLoadingSpinnerVisibility(loadingSpinner, isLoading);
            update.routerImage && updateImage(routerImage, selectedId);

            if (update.customer) {
                toggleElementVisibilityById(CustomerInfoId.WRAPPER, isLoggedIn);
                customer && updateCustomerInfo(customer);
            }

            if (update.disableBooking) {
                toggleElementVisibilityById(AppId.OFFER_SUMMARY_CARD, !disableBooking);
            }

            toggleElementVisibilityById(AppId.APP_CONTAINER, !isInitError);
            toggleElementVisibilityById(AppId.ERROR_CONTAINER, isInitError);
            toggleElementVisibilityById(AppId.AVC_ERROR_CONTAINER, isAvcError);
            initFootnotes(footnoteAccordion);
        },
    };
}

export default connect(mapStateToProps, mapDispatch)(container);
